import { Extension } from '../../api';

export type ExtensionShape = {
  extensions: Extension[];
  selectedIds: Extension['id'][];
  expandedKeys: Extension['id'][];
  loading: boolean;
};

export const ALL_EXTENSIONS_ID = '.';
export const ALL_EXTENSIONS_NAME = 'All types';

export const sortExtensions = (a: Extension, b: Extension) =>
  a.name.toLowerCase().localeCompare(b.name.toLowerCase());
